import React from 'react';
import { createPortal } from 'react-dom';
import styles from './PresSlider.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { IoMdClose } from 'react-icons/io';
export default function PresSlider ({ onClose, catalogsData }) {
    const data = catalogsData;
    return createPortal(
        <div className={styles.presSlider}>
            <div className={styles.sliderContent}>
                <button className={styles.closeButton} onClick={onClose}><IoMdClose /></button>
                <div className={styles.content}>
                    <Swiper
                        className={styles.swiper}
                        modules={[Navigation]}
                        slidesPerView={1}
                        navigation
                        loop={true}
                    >
                        {data?.map((item, i) => {
                            return (
                                <SwiperSlide key={i} className={styles.item}>
                                    <img src={`https://cdn.publisher.masterwizr.com/${item?.assest_urls?.[0]?.original}`} alt={item.title} />
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </div>
            </div>
        </div>,
        document.body
    );
}
